import React from 'react'
import { StarChartclonePresentationProps } from '../../types/types'
import { DialogContent } from '@mui/material'
import { images } from '../../../../constants'
import { StarChartOrgAssignOrgDialogStyle, StarChartOrgAssignOrgCloseIcon, StarChartOrgAssignOrgFormCol, StarChartOrgAssignOrgTitle, StarChartOrgAssignOrgDesc, StarChartOrgAssignOrgList } from './StarChartOrgAssignOrganizationPresentation.style'
import { SaveButton } from '../../../students/presantation/studentAddPresentation/student.add.presentation'
import StarChartOrgCloneItem from './StarChartOrgCloneItem'


const StarChartOrgClonePresentation: React.FC<StarChartclonePresentationProps> = ({starChartClone , clonePopup}) => {

const list: any[] = [
    "Star Chart 1",
    "Star Chart 2",
    "Star Chart 3",
    "Star Chart 4",
    "Star Chart 5",
    "Star Chart 6",
    "Star Chart 7",
    
]

  return (
    <StarChartOrgAssignOrgDialogStyle
    open={starChartClone}
    onClose={clonePopup}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent sx={{ width: '500px', padding: '24px' }}>

        <StarChartOrgAssignOrgCloseIcon
            onClick={clonePopup}
            src={images.closeIconSimple}
                            
        />
        <StarChartOrgAssignOrgFormCol alignment="flex-start" Direction={'column'}>
                <StarChartOrgAssignOrgTitle>Clone Star Chart</StarChartOrgAssignOrgTitle>
                <StarChartOrgAssignOrgDesc style={{paddingBottom:15}}>Select a star chart in base to clone</StarChartOrgAssignOrgDesc>
                <StarChartOrgAssignOrgList>
                    {list.map((item) => (
                        <StarChartOrgCloneItem
                            organizationName={item}
                            key={item}
            
                        />
                    ))}
                </StarChartOrgAssignOrgList>

        </StarChartOrgAssignOrgFormCol>
        <StarChartOrgAssignOrgFormCol alignment="flex-end" Direction={'row'} style={{width:"100%", paddingTop:15}}>
                  
                        <SaveButton
                          style={{ marginLeft: '15px', width: '70px',backgroundColor:"#34C38F" ,borderRadius:5 , padding:8 , fontSize:14}}
                          onClick={clonePopup}
                        >
                          Clone
            
                          
                        </SaveButton>

        </StarChartOrgAssignOrgFormCol>


      </DialogContent>
    </StarChartOrgAssignOrgDialogStyle>


  )
}

export default StarChartOrgClonePresentation